import { type ColumnDef } from '@tanstack/react-table';
import { ColumnType } from '@/types/column';
import { type GalleryView } from '@/types';

interface DimensionsColumnOptions<_T> {
  id?: string;
  enableSorting?: boolean;
  enableHiding?: boolean;
  size?: number;
  minSize?: number;
  maxSize?: number;
  label?: string;
  cellClassName?: string;
  headerClassName?: string;
  dataCy?: (rowIndex: number) => string;
  galleryView?: GalleryView;
}

export const DimensionsColumn = <T extends Record<string, any>>({
  id = ColumnType.Dimensions,
  label = 'Dimensions',
  size = 110,
  cellClassName,
  headerClassName,
  enableSorting = false,
  enableHiding = true,
  minSize,
  maxSize,
  dataCy,
  galleryView,
}: DimensionsColumnOptions<T> = {}): ColumnDef<T> => ({
  id,
  enableSorting,
  enableHiding,
  minSize,
  maxSize,
  ...((cellClassName ?? headerClassName) && {
    meta: {
      ...(cellClassName && { cellClassName: cellClassName }),
      ...(headerClassName && { headerClassName: headerClassName }),
    },
  }),
  size,
  header: () => label,
  accessorFn: (asset) => (asset.width && asset.height ? `${asset.width}x${asset.height}` : ''),
  cell: ({ getValue, row }) => (
    <p className="whitespace-nowrap text-text-gray" data-cy={dataCy ?? `${galleryView ?? 'list'}-${row.index}-${id}`}>
      {getValue() as string}
    </p>
  ),
});
